<template>
  <div>
    <!-- {{ items }} -->
    <DxForm
      :form-data="formData"
      :items="items"
      :label-location="labelLocation"
      @fieldDataChanged="handleFieldChange"
    >
      <template #form-checkbox-group="{ data: item }">
        <CheckboxGroup v-model="formData[item.dataField]" :checkList="item">
        </CheckboxGroup>
      </template>

      <template #form-invoice-item="{ data: { dataField, editorOptions } }">
         <!-- {{ formData[dataField] }}   -->
        <InvFieldType
          v-model="formData[dataField]"
          :fname="dataField"
          :modRoute="routeDef"
          :slug="slug"
          :def="editorOptions"
          :partyLedgerId="formData['cnsl_ledger_id']"
        />
      </template>

      <template #form-line-item="{ data: item }">
        <div>
          <!-- {{formData[item.dataField]}} -->

          <LineItemField
            v-model="formData[item.dataField]"
            :ref="item.dataField + 'field'"
            :fname="item.dataField"
            :modRoute="routeDef"
            :slug="slug"
            :def="item.editorOptions"
          />
        </div>
      </template>

      <!-- <template #form-rlt="{ data: item }">
        <div>
          <DropDataGrid
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :slug="slug"
          >
          </DropDataGrid>
        </div>
      </template> -->
      <template #cstm_field="{ data: item }">
        <div>
          <custom-field-types
            :item="item"
            :prefix="slug"
            :routeDef="routeDef"
            :defaultDate="defaultDate"
            v-model="formData[item.dataField]"
            @onTransactionDateChanged="handleTransactionDate"
            @onRelateValueChanged="updateCheckboxValue"
            :viewType="viewType"
             :createDef="createDef"
             :modelData="modelData"
          >
          </custom-field-types>
        </div>
      </template>

      <template #form-trn="{ data: item }">
        <div>
          <transaction
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :rltName="item.editorOptions.rltName"
            :trname="item.editorOptions.moduleTransactionSeries"
            :currentModuleId="item.editorOptions.currentModuleId"
            @transaction_selection="handleTransactionDate"
            :disabled="item.editorOptions.disabled"
           
            :slug="slug"
          >
          </transaction>
        </div>
      </template>

      <template #morph-rlt="{ data: item }">
        <div>
          <MorphField
            :prefix="slug"
            v-model="formData[item.dataField]"
            :rRoute="item.editorOptions.relateModule"
            :fname="item.editorOptions.rltName"
          >
          </MorphField>
        </div>
      </template>
      <!-- textbox with listener -->
      <template #form-textbox="{ data: item }">
        <div>
          <DxTextBox
            v-model="formData[item.dataField]"
            :fname="item.dataField"
          />
        </div>
      </template>

      <template #dependent_field="{ data: item }">
        <div>
          <!-- {{item.editorOptions.dependentOnName}} -->
          <!-- <ComponentTwo
          v-model="formData[item.dataField]"
          :checkboxValue="checkboxValue"
          :ledgerId="formData[item.editorOptions.dependentOnName]"
        /> -->
          <DependentDropComponent
            v-model="formData[item.dataField]"
            :slug="slug"
            :rRoute="routeDef"
            :onRelateValueChanged="checkboxValue"
            :dependentOnId="formData[item.editorOptions.dependentOnName]"
            :dependentOn="item.editorOptions.dependentOn"
            :depedentModule="item.editorOptions.depedentModule"
            :dependentRoute="item.editorOptions.dependentRoute"
            :disabled="item.editorOptions.disabled"
            :dependentModuleRoute ="item.editorOptions.dependentModuleRoute"
          />
        </div>
      </template>
    </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";

import CustomStore from "devextreme/data/custom_store";
import DropDataGrid from "../components/DropDataGrid.vue";
import MorphField from "../components/MorphField.vue";
import DxTextArea from "devextreme-vue/text-area";
import DxTextBox from "devextreme-vue/text-box";
import RelateTemp from "@/Layouts/RelateFieldTemplate.vue";
import LineItem from "@/components/LineItemCompo.vue";
import InvoiceField from "@/components/InvoiceFieldCompo.vue";
import CustomFieldTypes from "@/components/CustomFieldTypes.vue";
import Transaction from "../components/TransactionComponent.vue";
import CheckboxGroup from "@/components/CstmCheckboxGroup.vue";
import { getQuickCreateDef } from "@include/utils/GridUtils.js";
import InvFieldType from "@/components/InvFieldTypeCompo.vue";
import LineItemField from "@/components/FieldLineItemTypeCompo.vue";
import DependentDropComponent from "../components/DependentDropComponent.vue";

export default {
  props: {
    createDef: Array,
    routeDef: String,
    defaultDate: Boolean,
    slug: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    viewType: String,
  },
  components: {
    DxForm,
    DxTextBox,
    getQuickCreateDef,
    LineItem,
    LineItemField,
    DropDataGrid,
    MorphField,
    InvoiceField,
    CheckboxGroup,
    CustomFieldTypes,
    InvFieldType,
    Transaction,
    DependentDropComponent,
  },
  data: function () {
    return {
      formData: this.modelData,
      labelLocation: "top",
      watchList: [],
      lineItemFieldList: [],
      log: console.log,
      items: this.createDef,
      fields: ["name", "address"],
      checkboxValue: false,
      fieldListner: [
        {
          field: "Test1_LineItem:address",
          relateFields: ["name", "Test1_LineItem:name"],
        },
        {
          field: "test1",
          relateFields: ["name"],
        },
        {
          field: "Test1_LineItem:address",
          relateFields: ["name"],
        },
      ],
    };
  },
  watch: {},
  methods: {
    callGrandchildMethod() {
      // Emit an event to trigger the grandchild method

      this.lineItemFieldList.forEach((dataField) => {
        console.log("Line Item value", dataField);
        //var fieldName  = dataField
        this.$refs[dataField + "field"].grandchildMethod();
      });
    },
    handleFieldChange(e) {
      // handle field change event
      //alert("hora");
    },
    makeAsyncDataSource(rRoute, slug) {
      return new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";
          var parameters = {};
          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }

          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
          //let url= "/"+slug+"/"+rRoute+'/getById/'+key;
          //let data ={};
          //const response = await getRecordByIdasync(url);
          //return response.data;
        },
      });
    },
    getProxyObj(data) {
      const proxy = new Proxy(data, {
        get(target, key) {
          if (key === "map") {
            return (callback) => {
              const result = target.map(callback);
              return new Proxy(result, this);
            };
          }
          return target[key];
        },
      });
      return proxy;
    },

    updateCheckboxValue(value) {
      // Update the checkboxValue when ComponentOne emits the event
      this.checkboxValue = value;
    },

    showMessage() {
      alert("done");
    },

    async getCalData(para) {
      let res = 0;

      //console.log("para",this.formData.Test_LineItem[0].name);
      /* await axios.get(
                  '/calfn',
                  {
                    params: para
                  }
                ).then(function (response) {
                  console.log(response.data);
                  
                  res = response.data;
                  
                }); */

      //this.formData[para.key] = 9;
    },

    handleTransaction(selectedValue) {
      //  this.formData.transaction_number = value.method_of_voucher_numbering;
      console.log("trn slectedValue", selectedValue);

      var relate_id = selectedValue.relate_id;
      var rltName = selectedValue.rltName;
      var rltModule = selectedValue.route;

      const netvalue = this.getRelatedTransactionDetail(
        relate_id,
        rltName,
        rltModule
      );

      const netResponse = async () => {
        const resp = await netvalue;
        console.log("Resp Data", resp.data);
        this.formData.transaction_number = resp.data;
        //this.formData.transaction_number = "saurabh";

        console.log("TRn formData ", this.formData);

        return resp;
      };

      console.log("NET VALUE", netResponse());
    },

    handleTransactionDate(selectedDateValue){

      console.log("handleTransactionDate",this.formData.rlt_fld_transaction_series);
      var url = "/trn/getTrnNumber";


      var parameters = {
       // transactionSeries:  this.formData.rlt_fld_transaction_series,
        //selectedDateValue:  selectedDateValue,
        transactionSeries:  this.formData.transaction_series,
        selectedDateValue:  this.formData.transaction_date,
        moduleRoute: this.routeDef,
        viewType: this.viewType,
        rocordId: this.formData.id,
      };

      
      console.log("handleTransactionDate parameters",parameters);

      var config = {
        params: parameters,
      };

      const axios_data = axios
        .get(url, config)
        .then((response) => {
         console.log(" transaction_number Date Response", response)
         this.formData.transaction_number = response.data;

          return response;
        })
        .catch(() => {
          throw "Data Loading Error";
        });

      const axiosResponse = async () => {
        const a = await axios_data;
        //console.log("Axios Data", a);
        return a;
      };

      return axiosResponse();


    },

    getRelatedTransactionDetail(relate_id, rltName, rltModule) {
      // var url = "/" + this.slug +"/"+ rltModule  +"/relatedata";
      var url = "/trn/relatedrecord";

      var parameters = {
        id: relate_id,
        relateName: rltName,
        moduleRoute: this.routeDef,
        viewType: this.viewType,
        rocordId: this.formData.id,
      };

      var config = {
        params: parameters,
      };

      const axios_data = axios
        .get(url, config)
        .then((response) => {
          // console.log(" NEW Response", response)
          return response;
        })
        .catch(() => {
          throw "Data Loading Error";
        });

      const axiosResponse = async () => {
        const a = await axios_data;
        //console.log("Axios Data", a);
        return a;
      };

      return axiosResponse();
    },
  },
  mounted() {
     console.log("BSEDIT create def",this.formData);
    //console.log("SLUG",this.slug);
    this.formData.transaction_number = null;
    const formLineItemDataFields = this.createDef
      .flatMap((section) => section.items || [])
      .filter((item) => item.template === "form-line-item")
      .map((item) => item.dataField);

    this.lineItemFieldList = formLineItemDataFields;

    //get all the relateFields from the fieldlistner and push them to watchList and filter the duplicate
    this.fieldListner.forEach((field) => {
      field.relateFields.forEach((relateField) => {
        if (this.watchList.indexOf(relateField) === -1) {
          this.watchList.push(relateField);
        }
      });
    });

    this.$watch("formData.name", (nval, oval) => {
      console.log("formData", this.formData);
    });

    //loop watchList and add watch to the field if the field is in the formData
    this.watchList.forEach((field) => {
      //check for line item field and add listener to the field
      if (field.includes(":")) {
        let fieldArr = field.split(":");
        let fieldName = fieldArr[0];
        let fieldLength = fieldArr[0] + ".items.length";
        let fieldRelate = fieldArr[1];
        //check line item field length and loop and add listener to the field
        this.$watch(
          `formData.${fieldLength}`,
          (newVal, oldVal) => {
            for (var i = 0; i < newVal; i++) {
              this.$watch(
                `formData.${fieldName}.items.${i}.${fieldRelate}`,
                (newVal, oldVal) => {
                  //it will check if the listener field present in the formData and if yes then it will add the listener
                  // filter fieldListner in the basis of the relatedFields match with the field
                  var filterFieldListner = this.fieldListner.filter(
                    (fieldListner) =>
                      fieldListner.relateFields.indexOf(field) !== -1
                  );

                  //loop the filterFieldListner
                  filterFieldListner.forEach((fieldListner) => {
                    var relateFieldValue = {};
                    var resultField = fieldListner.field;
                    var result = 0;
                    //loop the relateFields in the fieldListner
                    fieldListner.relateFields.forEach((relateField) => {
                      relateFieldValue[relateField] =
                        this.formData[relateField];
                    });
                    //pass the relateFieldValue for the calculation
                    this.getCalData({
                      module: this.routeDef,
                      key: resultField,
                      prams: relateFieldValue,
                    });
                  });
                }
              );
            }
          },
          {
            deep: true,
          }
        );

        return;
      } else {
        let fieldName = field;
      }

      if (!this.formData[field]) {
        this.$watch(
          `formData.${field}`,
          (newVal, oldVal) => {
            //it will check if the listener field present in the formData and if yes then it will add the listener
            // filter fieldListner in the basis of the relatedFields match with the field
            var filterFieldListner = this.fieldListner.filter(
              (fieldListner) => fieldListner.relateFields.indexOf(field) !== -1
            );

            //loop the filterFieldListner
            filterFieldListner.forEach((fieldListner) => {
              var relateFieldValue = {};
              var resultField = fieldListner.field;
              var result = 0;
              //loop the relateFields in the fieldListner
              fieldListner.relateFields.forEach((relateField) => {
                relateFieldValue[relateField] = this.formData[relateField];
              });
              //pass the relateFieldValue for the calculation
              this.getCalData({
                module: this.routeDef,
                key: resultField,
                prams: relateFieldValue,
              });
            });
          },
          { deep: true }
        );
      }
    });

    if (this.createDef.length == 0) {
      getQuickCreateDef(this.routeDef)
        .then((response) => {
          this.createDef = response.data.results;
        })
        .catch((error) => {});
    }
  },
  created(){
       // console.log("TRN SERIES CREATED DEFAULT", this.formData.transaction_number);

  }
};
</script>

<style>
.dx-form .dx-field-item-label {
  font-size: 12px;
  margin-bottom: 0px;
}
.createName {
  background-color: white !important;
  margin-top: 10px;
  padding: 10px 30px;
}
.dx-form-group-caption {
  font-size: 14px;
  font-weight: bold;
  color: #535252;
}
</style>